


import { type ThemeOptions } from '@mui/material'
import { createTheme } from '@mui/material/styles'

import { normalize } from './normalize'
import { breakpoints } from './breakpoints'
// import * as components from '../components'
import { palette } from './palette'
import { shadows } from './shadows'
import { shape } from './shape'
import { spacing } from './spacing'
import { typography } from './typography'
import { MuiCheckbox } from '../../settings/mui/MuiCheckbox'
import type {} from '@mui/x-charts-pro/themeAugmentation';


export const options: ThemeOptions = {
  colorSchemes: {
    light: {
      palette,
    },
    dark: {
      palette,
    },
  },
  cssVarPrefix: 'mui',
  colorSchemeSelector: 'class',
  breakpoints,
  shape,
  ...shadows,
  typography,
  ...spacing,
  components: {
    MuiUseMediaQuery: {
      defaultProps: {
        noSsr: true,
      },
    },
    MuiCheckbox,
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '.MuiFilledInput-root': {
            paddingTop: 0,
            paddingLeft: 8,
            paddingRight: 8,
          },
          '.MuiInputBase-input': {
            paddingTop: 0,
          },
          '&.MuiAutocomplete-hasPopupIcon .MuiFilledInput-root, &.MuiAutocomplete-hasClearIcon .MuiFilledInput-root': {
            paddingRight: 8,
          },
        },
        inputRoot: {
          paddingTop: 0,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: normalize,
    },
    // ...components,
  },
}

export const theme = createTheme(options)
